import type { MetaInfo } from 'streams/views/mainContent/types';
import { dispatchAction } from '@ardoq/rxbeach';
import { setMetamodels } from 'streams/metamodels/metamodelActions';
import { isPlainObject } from 'lodash';
import {
  EnhancedPresentation,
  PersistedMetamodel,
  APIPresentationAttributes,
} from '@ardoq/api-types';
import { APIFieldAttributes } from '@ardoq/api-types/';
import { dateRangeOperations } from '@ardoq/date-range';
import { getSlideMigrationInfo } from './actions';
import { toPresentationAsset } from './toPresentationAsset';
import { hasDeprecatedSlides } from 'viewDeprecation/util';
import { setPresentation } from 'streams/context/ContextActions';

export const loadMetamodels = (
  metamodels: Record<string, PersistedMetamodel>,
  fields: APIFieldAttributes[]
) => {
  if (isPlainObject(metamodels)) {
    const entries = Object.entries(metamodels).map(([k, v]) => ({
      ...dateRangeOperations.mergeDateRangeFieldsOnMetamodel(
        v,
        (workspaceId: string) => {
          const modelId = Object.values(v.metamodel.workspaces).find(
            workspace => workspace.id === workspaceId
          )?.modelId;
          return fields.filter(field => field.model === modelId);
        }
      ),
      _id: k,
    }));
    dispatchAction(setMetamodels(entries));
  }
};

const getPresentationSlidesMigrationInfo = (
  presentation: APIPresentationAttributes,
  deprecatedViews: MetaInfo[]
) => {
  // If the presentation has changed and has "discontinued slides", we need the current SlidesMigrationInfo.
  // Read about the logic and relevant code parts in
  // https://ardoqcom.atlassian.net/wiki/spaces/INSIGHT/pages/2413002789/Discontinued+Views+engineering+perspective.

  if (hasDeprecatedSlides(presentation.authorizedSlides, deprecatedViews)) {
    dispatchAction(getSlideMigrationInfo(presentation));
  }
};

export const setPresentationInContext = (
  presentation: EnhancedPresentation,
  deprecatedViews: MetaInfo[]
) => {
  dispatchAction(setPresentation(toPresentationAsset(presentation)));
  getPresentationSlidesMigrationInfo(presentation, deprecatedViews);
  return presentation;
};
